import { clientShopId } from 'config/const';
import get from 'lodash.get';
import {
  callTpFetch,
  callFetch,
  header,
  idTokenHeader,
  tokenHeader,
} from './utils';

const EndPoint = {
  RefreshIdToken: (shopId) =>
    `/linewebhook/customer/shop/${shopId}/oauth/refresh`,
  GetClientForm: (lineId) => `/client/${lineId}/check-form?options=idToken`,
  GetClientDetail: (lineId) => `/client/${lineId}/profile`,
  UpdateClientDetail: (lineId) => `/client/${lineId}/profile`,
  PostClient: () => `/client`,
  UpdateClientAgent: (lineId, agentId) => `/client/${lineId}/agent/${agentId}`,
  UpdateTpCustomer: (lineId) =>
    `/linewebhook/customer/shop/${clientShopId}/${lineId}`,
};

// Customer
export async function getCustomerForm(lineId, accessToken) {
  const result = await getClientForm(lineId, accessToken);

  const isFormExist = get(result, 'data.isFormExist');
  if (typeof isFormExist === 'boolean')
    return {
      ...get(result, 'data.user', {}),
      isFormExist,
    };
  else return result;
}

function getClientForm(lineId, accessToken) {
  const uri = EndPoint.GetClientForm(lineId);
  let settings = {
    method: 'POST',
    headers: { ...header },
    body: JSON.stringify({
      operations: ['formStatus', 'userData'],
      accessToken,
    }),
  };
  return callFetch(uri, settings);
}

export function getCustomerDetail(lineId) {
  return getClientDetail(lineId);
}

function getClientDetail(lineId) {
  const uri = EndPoint.GetClientDetail(lineId);
  let settings = {
    method: 'GET',
    headers: { ...header },
  };

  return callFetch(uri, settings);
}

export function createCustomer(data, accessToken) {
  return createClient(data, accessToken);
}

export function createClient(data, accessToken) {
  const uri = EndPoint.PostClient();
  let settings = {
    method: 'POST',
    headers: { ...header },
    body: JSON.stringify({ accessToken, ...data }),
  };
  return callFetch(uri, settings);
}

export function refreshIdToken(token) {
  const uri = EndPoint.RefreshIdToken();
  let settings = {
    method: 'POST',
    headers: header,
    body: JSON.stringify({ refreshToken: token }),
  };

  return callFetch(uri, settings);
}

export function updateClientDetail(lineId, accessToken, data = {}) {
  const uri = EndPoint.UpdateClientDetail(lineId);
  let settings = {
    method: 'PATCH',
    headers: { ...header },
    body: JSON.stringify({ accessToken, ...data }),
  };
  return callFetch(uri, settings);
}

export function updateClientAgent(lineId, agentId) {
  const uri = EndPoint.UpdateClientAgent(lineId, agentId);
  let settings = {
    method: 'PATCH',
    headers: { ...header },
  };
  return callFetch(uri, settings);
}

export function updateTpCustomer(lineId, idToken, data = {}) {
  const uri = EndPoint.UpdateTpCustomer(lineId);
  let settings = {
    method: 'PATCH',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify(data),
  };

  return callTpFetch(uri, settings);
}
